import React, { PureComponent } from "react";
import Popup from "./Popup.js";
import Button from "../Button/Button.js";
import Constants from '../Constants.js';
import PlatformTest from '../PlatformTest.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faApple, faAndroid } from '@fortawesome/free-brands-svg-icons'
library.add(faApple);
library.add(faAndroid);



class PopupDownloadApp extends PureComponent {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.popup = React.createRef();
    }

    show() {
        this.popup.current.show();
    }
    hide() {
        this.popup.current.hide();
    }

    render() {

        // Default to showing both buttons
        let buttons = <div>
            <a href={Constants.iosDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faApple} />
                    iOS
                </Button>
            </a>
            <a href={Constants.androidDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faAndroid} />
                    Android
                </Button>
            </a>
        </div>
        // If iOS, show only iOS download button
        if (PlatformTest.ios()) {
            buttons = <a href={Constants.iosDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faApple} />
                    Download App
                </Button>
            </a>
        }
        // If Android, show only Android download button
        else if (PlatformTest.android()) {
            buttons = <a href={Constants.androidDownloadLink} target="_blank" rel="noopener noreferrer">
                <Button
                    activeColor={'#fff'}
                    inactiveColor={'#3c40c6'}
                    borderColor={'#3c40c6'}
                >
                    <FontAwesomeIcon className="ButtonIcon" icon={faAndroid} />
                    Download App
                </Button>
            </a>
        }

        return (
            <Popup
                ref={this.popup}
                showing={false}
            >
                <h1 className="Title">
                    Download the App?
                </h1>
                <div
                    style={{
                        borderBottom: '1px solid #f7f7f7',
                        height: '320px',
                        overflow: 'hidden',
                        marginBottom: '25px',
                    }}
                >
                    <div className="Image"></div>
                </div>
                <p className="Paragraph">
                    {Constants.name} is better in app form. Download the free app on iOS or Android for hints and {Constants.paidLevels} more levels!
                </p>
                {buttons}
            </Popup>
        );
    }
}

export default PopupDownloadApp;
